define([
    "dojo/_base/declare",
    "dojo/_base/event",
    "dojo/dom",
    "dojo/dom-style",
    "dojo/on",
    "dojo/mouse",
    "dojo/touch",
    "dijit/_TemplatedMixin",
    "dijit/_WidgetBase",
    "MW/layout/LayoutUtils",
    "dojo/text!./templates/TabGroupHeader.html"
], function (declare, event, dom, domStyle, on, mouse, touch, _TemplatedMixin, _WidgetBase, LayoutUtils, HeaderTemplate) {

    return declare([_WidgetBase, _TemplatedMixin], {

        templateString: HeaderTemplate,

        buildRendering: function () {
            this.inherited(arguments);
            this.labelNode.textContent = this.label;

            dom.setSelectable(this.domNode, false);
            LayoutUtils.preventFocus(this.domNode, true);
            LayoutUtils.preventDefaultContextMenu(this.domNode);
            LayoutUtils.setLocaleOnDomNode(this.domNode);

            var that = this;
            if (this.createMenu) {
                on(this.actionsNode, touch.press, function (e) {
                    if (mouse.isLeft(e) && !that.menu) {
                        that.menu = that.createMenu();
                        that.menu.targetNodes = [that.actionsNode];
                        that.menu.on("close", function () {
                            that.menuCloseCallback();
                            // Error results if menu destroyed in scope of onClose
                            setTimeout(function () {
                                that.menu.destroyRecursive();
                                delete that.menu;
                            }, 0);
                        });
                        that.menu.open({target: e.target});
                        event.stop(e);
                    }
                });
                this.contextMenu = this.createMenu(true /* isContextMenu */);
                this.contextMenu.targetNodes = [this.domNode, this.labelNode];
                this.own(this.contextMenu);
            } else {
                domStyle.set(this.actionsNode, {display: "none"});
            }
        }
    });
});
